// extracted by mini-css-extract-plugin
module.exports = {"description":"y9V2gswqoRAlJd7znuJI"};